// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/blog.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/blog.tsx");
  import.meta.hot.lastModified = "1716289823160.688";
}
// REMIX HMR END

import { Outlet } from "@remix-run/react";
export const meta = ({
  location
}) => {
  const parts = location.pathname.split("/");
  const path = parts[parts.length - 1];
  return [{
    title: `${path} | Tom Frantz`
  }, {
    name: "description",
    content: `the ${path} blog post, authored by Tom Frantz`
  }];
};

// The layout for all individual blog.
// The `/blog` page ignores this
const BlogLayout = () => {
  return <div className=" px-2 py-16 text-black sm:px-8 ">
      <div className="prose mx-auto max-w-2xl lg:prose-lg lg:max-w-5xl">
        <Outlet />
      </div>
    </div>;
};
_c = BlogLayout;
export default BlogLayout;
var _c;
$RefreshReg$(_c, "BlogLayout");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;